/**
 * @description CreateCompanyPage — Scenario 3 wrapper for multi-company self-service creation
 *
 * Key features:
 * - Auto-opens OnboardingModal on mount (no empty state needed)
 * - After modal completion → navigates to dashboard (new company in switcher)
 * - If user cancels before completion → navigates back to dashboard
 * - Reuses the full onboarding flow (business info, details, payment setup)
 *
 * @dependencies
 * - OnboardingModal: Full onboarding wizard (handles company creation + context refresh)
 *
 * @notes
 * - Rendered inside MerchantLayout (user is already authenticated with an existing company)
 * - OnboardingModal internally calls refreshContext/refreshCompanyContext/refreshPermissions
 * - After creation, the new company appears in CompanySwitcher
 * - The user is auto-switched to the new company via the context refresh
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingModal from '../onboarding/OnboardingModal';

const CreateCompanyPage = () => {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    // Navigate to dashboard — OnboardingModal already refreshed context,
    // so the new company will be in the switcher
    navigate('/merchant/dashboard', { replace: true });
  }, [navigate]);

  return (
    <div>
      <OnboardingModal isOpen={true} onClose={handleClose} />
    </div>
  );
};

export default CreateCompanyPage;
